export default "__VITE_ASSET__9ccda6f8__"